/** What the player is told when the per-bank card cap moved a card (ADR-0081). Nothing the api serves yet says so (contract wall): these are drawn from props, wired when the field arrives. */

/** On a bank-level finding that was held over from last year's round: marked, with one sentence. */
export function DelayedNote() {
  return <p className="gx-ev-callout gx-ev-delayed" data-testid="event.delayed"><b>Delayed from last year.</b> The examiners could not fit this one into last year, so it reaches you now.</p>;
}

/** A market-wide review that the cap dropped: the card list says so in one line, with nothing to answer. */
export function RoutineReviewLine({ titles }: { readonly titles: readonly string[] }) {
  if (titles.length === 0) return null;
  return <p className="gx-small gx-muted" data-testid="events.routine">{titles.join(" and ")}: routine review, no action.</p>;
}
